<template>
  <DxRadioGroup
    :items="[{ id: 1 }]"
    valueExpr="id"
    :value="setValue == 'Y' ? 1 : null"
    :onValueChanged="radioValueChange"
    :disabled="disabled"
    :elementAttr="{ class: 'gc-field-radio-wrapper' }"
  />
</template>
<script>
export default {
  components: {},
  props: {
    valueChangeCallBack: {
      type: Function,
      default: () => function () {},
    },
    data: {
      type: [Object, Array],
      default: () => {},
    },
    value: {
      type: String,
      default: "N",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      setValue: this.value,
    };
  },
  created() {},
  computed: {},
  methods: {
    radioValueChange(e) {
      this.valueChangeCallBack(this.data, e);
    },
  },
};
</script>

<style lang="scss">
.gc-field-radio-wrapper {
  .dx-radiobutton-icon {
    width: 16px !important;
    height: 16px !important;
    position: relative;
  }
  .dx-radiobutton-icon:after {
    margin-top: -18px;
    margin-left: -18px;
  }
}
</style>
